import { ErrorType } from "~/enums/ErrorType";
import { ValidationErrorMessage } from "~/enums/validationErrorMessage";
import { ObjectHelper } from "~/helpers/objectHelper";
import ValidationError from "../validationError";
import Visualization from "../visualizations/visualization";
import NavigableValidator from "./navigableValidator";

export default class VisualizationDataPointValidator extends NavigableValidator<Visualization> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePublished;

  protected _validate(model: Visualization): void {
    const sources = ObjectHelper.toArray(model.sources);

    for (const source of sources) {
      if (!source.isPublished && !source.source.published_object_model_id) {
        this.errors.push(this.buildValidationError(model, 'Data Source must be published.', source.titleOrDefault, 'sources_' + source.client_id));
      }
    }
  }

  buildValidationError(model: any, value?, displayName?, validatorKey?, type?) {
    const messageFromOptions = "Data Source must be published."

    return new ValidationError({
      message: messageFromOptions || this.defaultMessage,
      displayName: displayName,
      errorNavOpts: this.errorNavOpts(model, validatorKey, value, type),
      field: validatorKey,
      type: this.options.type || type || this.defaultType,
      section: this.section,
      level: this.errorLevel,
    });
  }

}